/**
 * Custom Swym wishlist buttons — SDK-only mode (swat.addToList/deleteFromList),
 * not Swym's auto-injected default UI. Requires the theme's Swym app embed
 * "Show UI" option OFF for product/collection buttons.
 * https://developers.getswym.com/reference/build-a-custom-wishlist-button-1
 */
(function () {
  'use strict';

  function isWishlisted(empi) {
    if (!window.swymWishLists) return false;
    return window.swymWishLists.some(function (list) {
      return list.listcontents.some(function (item) {
        return String(item.empi) === String(empi);
      });
    });
  }

  function setButtonState(btn, wishlisted) {
    btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    var label = btn.querySelector('.js-wishlist-toggle-label');
    if (label) {
      label.textContent = wishlisted
        ? btn.getAttribute('data-label-remove')
        : btn.getAttribute('data-label-add');
    }
  }

  function refreshAllButtons() {
    document.querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
      btn.classList.remove('invisible');
      setButtonState(btn, isWishlisted(btn.getAttribute('data-product-id')));
    });
  }

  // Same data as the other events: the PDP's view_item item, otherwise the button's own card
  function wishlistItemData(GZAnalytics, btn, empi) {
    var pdpItem = document.getElementById('ProductAnalyticsItem');
    if (pdpItem) {
      var item = JSON.parse(pdpItem.textContent);
      if (String(item.item_id) === String(empi)) return item;
    }
    var productEl = btn.closest('[data-item-id="' + empi + '"]') || document.querySelector('[data-item-id="' + empi + '"]');
    return productEl ? GZAnalytics.readItemDataset(productEl) : {};
  }

  function pushWishlistEvent(GZAnalytics, eventName, btn, product, overrides) {
    var enrichment = wishlistItemData(GZAnalytics, btn, product.empi);
    var item = GZAnalytics.buildItemObject(
      Object.assign({}, enrichment, {
        item_id: String(product.empi),
        item_variant_id: enrichment.item_variant_id || product.epi,
        currency: window.GZShopCurrency
      }),
      overrides
    );
    GZAnalytics.pushEcommerce(eventName, { items: [item] });
  }

  function runWishlistAction(swat, lid, btn, product, wasWishlisted) {
    var onSuccess = function () {
      btn.disabled = false;
      setButtonState(btn, !wasWishlisted);
      btn.dispatchEvent(
        new CustomEvent('wishlist:changed', { bubbles: true, detail: { empi: product.empi, wishlisted: !wasWishlisted } })
      );

      window.GZAnalyticsQueue = window.GZAnalyticsQueue || [];
      window.GZAnalyticsQueue.push(function (GZAnalytics) {
        pushWishlistEvent(
          GZAnalytics,
          wasWishlisted ? 'remove_from_wishlist' : 'add_to_wishlist',
          btn,
          product,
          wasWishlisted ? { item_list_name: 'wishlist' } : { item_list_name: null }
        );
      });
    };
    var onError = function (error) {
      btn.disabled = false;
      if (swat.ui && swat.ui.showErrorNotification) {
        swat.ui.showErrorNotification({ message: 'Something went wrong. Please try again.' });
      }
      console.error('Swym wishlist action failed:', error);
    };

    if (wasWishlisted) {
      swat.deleteFromList(lid, product, onSuccess, onError);
    } else {
      swat.addToList(lid, product, onSuccess, onError);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-wishlist-toggle');
    if (!btn || btn.disabled) return;

    var variantInput = document.getElementById('product-variant-id');
    var variantId = (variantInput && variantInput.value) || btn.getAttribute('data-variant-id');
    var product = {
      empi: Number(btn.getAttribute('data-product-id')),
      epi: variantId ? Number(variantId) : undefined,
      du: btn.getAttribute('data-product-url') || (window.location.origin + window.location.pathname)
    };
    var wasWishlisted = btn.getAttribute('aria-pressed') === 'true';

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      btn.disabled = true;

      if (!window.swymSelectedListId) {
        swat.createList(
          { lname: 'My Wishlist' },
          function (result) {
            window.swymSelectedListId = result.lid;
            runWishlistAction(swat, result.lid, btn, product, wasWishlisted);
          },
          function (error) {
            btn.disabled = false;
            if (swat.ui && swat.ui.showErrorNotification) {
              swat.ui.showErrorNotification({ message: 'Something went wrong. Please try again.' });
            }
            console.error('Swym createList failed:', error);
          }
        );
        return;
      }

      runWishlistAction(swat, window.swymSelectedListId, btn, product, wasWishlisted);
    });
  });

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    swat.fetchLists({
      callbackFn: function (lists) {
        window.swymWishLists = lists;
        window.swymSelectedListId = lists && lists[0] && lists[0].lid;
        refreshAllButtons();
      },
      errorFn: function (error) {
        console.error('Swym fetchLists failed:', error);
      }
    });
  });
})();
